module.exports = __webpack_public_path__ + "img/desc.c5ba7360.png";